import { Fragment } from '@app/modules/fragments/types';
import { videoEditor, webApi } from '@mi-front/api-clients';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

/**
 * Prefetches queries used by the fragment view tabs (video-editions projects list,
 * publish/social export panorama uploads) so data is ready when the user switches tabs.
 */
export function useFragmentViewPreload(fragment: Fragment) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!fragment) return;

    const { id: fragmentId, stationId } = fragment;

    const projectsOptions = videoEditor.projectsListQueryOptions({
      sourceType: 'FRAGMENT',
      sourceId: fragmentId,
    });
    void queryClient.prefetchQuery(projectsOptions);

    const socialUploadsOptions =
      webApi.getFragmentSocialUploadsByFragmentIdQueryOptions(fragmentId);
    void queryClient.prefetchQuery(socialUploadsOptions);

    const socialConnectionsOptions =
      webApi.getSocialConnectionsConnectionsForStationQueryOptions(stationId);
    void queryClient.prefetchQuery(socialConnectionsOptions);
  }, [fragment.id, queryClient]);
}
